const KEY = "qhh.lists.queue";

export const newId = () => (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);
export const readQueue = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (_) { return []; } };
const write = (q) => localStorage.setItem(KEY, JSON.stringify(q));
export const enqueue = (op) => write([...readQueue(), { ...op, id: op.id || newId(), at: Date.now() }]);
export const dequeue = (id) => write(readQueue().filter((o) => o.id !== id));
export const isNetErr = (e) => !e?.response;
